import Plugin from 'lib/modulor/plugin'

export default class Playlist extends Plugin
  @defaults =
    debug: false
    name: 'AudioModule__Playlist'
    playlist_item_class_name: "audio_module__playlist__item"
    playlist_item_selector: ".audio_module__playlist__item"

  @selector: ".audio_module__playlist"

  on_init: ->
    @$element.on "ended.#{@options.name}", 'audio', (e) =>
      $playlist_item = $(e.currentTarget).closest(@options.playlist_item_selector)
      $playlist_item.trigger('reset')
      if $next_playlist_item = $playlist_item.next(@options.playlist_item_selector)
        $next_playlist_item.trigger('play')

    @$element.on "play.#{@options.name}", @options.playlist_item_selector, (e) =>
      @get_playlist_items().not($(e.currentTarget)).trigger('pause')

  get_playlist_items: -> @$element.find(@options.playlist_item_selector)

Playlist.register()
